module.exports = __webpack_public_path__ + "static/media/Wellness01.92035a08.jpeg";